<template>
  <div class="full-height">
    <foobar-header></foobar-header>
    <intro></intro>
    <section-intro :title="$t('message.title.main.foobars')"></section-intro>
    <foobar-list></foobar-list>
    <foobar-footer></foobar-footer>
  </div>
</template>

<script>
  import Intro from '@/components/partials/IntroLarge'
  import FoobarHeader from '@/components/partials/Header'
  import FoobarFooter from '@/components/partials/Footer'
  import FoobarList from '@/components/foobar/FoobarList'
  import SectionIntro from '@/components/partials/SectionIntroZeroOne'

  export default {
    components: {
      Intro,
      FoobarFooter,
      FoobarHeader,
      FoobarList,
      SectionIntro
    }
  }
</script>



// WEBPACK FOOTER //
// Foobars.vue?c04b5376